import { styled } from "@mui/material";
import { styledOmitPropsOptions } from "../../theme/styled.helpers";
import * as ModalSlideUpStyled from "./ModalSlideUp.styled";

export const ModalPaper = styled(
    ModalSlideUpStyled.ModalPaper,
    styledOmitPropsOptions,
)(({ theme }) =>
    theme.unstable_sx({
        minHeight: "40vh",
        justifyContent: "space-between",
    }),
);
